import { Component, DoCheck, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { iDataSource, IDataSourceService } from '../../../services/DataSourceServices/IDataSourceService.service';
import { FuelGaugeChartOptions } from '../../charts/fuel-gauge-new/fuel-gauge-new.component';
import { Single } from '../../../interfaces/single.interface';
import { EveReportingWidgetDataSource } from '../widget-menu-settings/widget-datasource/widget-datasource.component';
import { EveReportingWidget, GraphClickEvent, GraphClickEventAlert, GraphClickEventTypes, GraphClickEventUrl } from '../widget.component';



@Component({
  selector: 'fuel-gauge-chart-widget',
  templateUrl: 'fuel-gauge-chart-widget.component.html',
  styleUrls: ['./fuel-gauge-chart-widget.component.css']
})
export class FuelGaugeChartWidgetComponent implements OnInit, DoCheck {

  options: FuelGaugeChartOptions;

  @Input()
  widget?: EveReportingFuelGaugeChartWidget = null;

  @Output()
  isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  hasErrored: EventEmitter<boolean> = new EventEmitter<boolean>();

  widgetObservables: BehaviorSubject<EveReportingWidget>;

  results: Observable<Single[]>;

  @Input()
  controlValue: Observable<string>;

  constructor(
    public dataSourceService: IDataSourceService
  )
  {

  }

  ngOnInit(): void {
    this.isLoading.emit(false);
    this.hasErrored.emit(false);

    this.options = {
      thresholds: null,
      gaugeType: this.widget?.gaugeType,
      gaugeLabel: this.widget?.gaugeLabel,
      gaugeAppendText: this.widget?.gaugeAppendText,
      thickness: this.widget?.thickness,
      animationDuration: this.widget?.animationDuration,
      cap: this.widget?.gaugeEndStyle,
      /*chartHeader: this.widget.chartHeader,
      xAxisLabel: this.widget.xAxisLabel,
      yAxisLabel: this.widget.yAxisLabel,*/
      colourScheme: this.widget?.colourScheme
    }

    //service import
    this.widgetObservables = new BehaviorSubject<EveReportingWidget>(JSON.parse(JSON.stringify(this.widget)));
    this.results = this.dataSourceService.SingleResults(this.widgetObservables, staticResults);
  }

  ngDoCheck(): void {

    /*if (this.options.chartHeader != this.widget.chartHeader) this.options.chartHeader = this.widget.chartHeader;
    if (this.options.xAxisLabel != this.widget.xAxisLabel) this.options.xAxisLabel = this.widget.xAxisLabel;
    if (this.options.yAxisLabel != this.widget.yAxisLabel) this.options.yAxisLabel = this.widget.yAxisLabel;*/
    if (this.options.colourScheme != this.widget?.colourScheme) this.options.colourScheme = this.widget.colourScheme;
    if (this.options.gaugeType != this.widget?.gaugeType) this.options.gaugeType = this.widget.gaugeType;
    if (this.options.cap != this.widget?.gaugeEndStyle) this.options.cap = this.widget.gaugeEndStyle;
    if (this.options.gaugeLabel != this.widget?.gaugeLabel) this.options.gaugeLabel = this.widget.gaugeLabel;
    if (this.options.gaugeAppendText != this.widget?.gaugeAppendText) this.options.gaugeAppendText = this.widget.gaugeAppendText;
    if (this.options.thickness != this.widget?.thickness) this.options.thickness = this.widget.thickness;
    if (this.options.animationDuration != this.widget?.animationDuration) this.options.animationDuration = this.widget.animationDuration;
    if (this.options.thresholds != this.widget?.thresholdSettings) { //TODO: this wont detect non changes correctly

      if (this.widget.thresholdSettings?.length > 0) {

        const thresholdSettings = {};

        this.widget.thresholdSettings.forEach(settings => {
          thresholdSettings[settings.minimumValue] = {
            color: settings.colour
          };
          if (settings.showInBackground) thresholdSettings[settings.minimumValue].bgOpacity = 0.2;
        });

        // Object.assign(this.thresholdSettingsObject, this.options.thresholdSettings.reduce((a, v) => ({ ...a, [v.minimumValue]: v.showInBackground ? { 'color': v.colour.toString(), 'bgOpacity': 0.2 } : { 'color': v.colour.toString() } }), {}));

        this.options.thresholds = thresholdSettings;
      }
      else {
        this.options.thresholds = null;
      }

    }

    if (JSON.stringify(this.widget) !== JSON.stringify(this.widgetObservables.value)) this.widgetObservables.next(JSON.parse(JSON.stringify(this.widget)));
    
  }

  public onSelect(data) {

    if (this.widget.onClick.type == GraphClickEventTypes.alert) {
      alert((this.widget.onClick as GraphClickEventAlert).text);
    }
    else if (this.widget.onClick.type == GraphClickEventTypes.url) {
      window.open((this.widget.onClick as GraphClickEventUrl).url,'_blank');
    }
    else {
      alert("default");
    }
    //this.select.emit(data);    
  }

}



export interface EveReportingFuelGaugeChartWidget extends EveReportingWidget, iDataSource {
  thresholdSettings?: gaugeThresholdSettings[],
  gaugeType?: string,
  gaugeLabel?: string,
  gaugeAppendText?: string,
  thickness?: number,
  animationDuration?: number,
  gaugeEndStyle?: string,
  colourScheme?: any,
  onClick?: GraphClickEvent,

  dataSource: EveReportingWidgetDataSource
}

export interface gaugeThresholdSettings {
  minimumValue: number,
  colour: string,
  showInBackground: boolean
}

const staticResults: Single[] = [
  {
    name: "User1",
    value: 84
  }
];
